import type { AgentMessage, TableSortState } from "../ai-chat-message-utils";
import type { SourceProductConfig } from "../ai-chat-source-products";
import { UserMessage } from "./UserMessage";
import { AssistantMessage } from "./AssistantMessage";

interface ChatMessageProps {
  message: AgentMessage;
  sourceProducts?: SourceProductConfig[];
  latestExchangeAnchorRef?: React.Ref<HTMLDivElement>;
  tableSort?: TableSortState;
  onTableSortChange: (sort: TableSortState) => void;
}

export const ChatMessage = ({
  message,
  sourceProducts,
  latestExchangeAnchorRef,
  tableSort,
  onTableSortChange,
}: ChatMessageProps) => {
  switch (message.role) {
    case "user":
      return (
        <UserMessage
          message={message}
          latestExchangeAnchorRef={latestExchangeAnchorRef}
        />
      );
    case "assistant":
      return (
        <AssistantMessage
          message={message}
          sourceProducts={sourceProducts}
          tableSort={tableSort}
          onTableSortChange={onTableSortChange}
        />
      );
    default:
      return null;
  }
};
